export const state = () => ({
  isPopupVisible: true
});

export const mutations = {
  HIDE_POPUP(state) {
    state.isPopupVisible = false;
  },

  SHOW_POPUP(state) {
    state.isPopupVisible = true;
  }
};

export const getters = {
  isPopupVisible(state) {
    return state.isPopupVisible;
  }
};

export const actions = {
  closePopup({ commit }) {
    commit("HIDE_POPUP");
  },

  openPopup({ commit }) {
    commit("SHOW_POPUP");
  }
};
